__turbopack_context__.v({
  "subtleBounce": "SupportButton-module-scss-module__Csn2Wa__subtleBounce",
  "subtlePulse": "SupportButton-module-scss-module__Csn2Wa__subtlePulse",
  "supportBadge": "SupportButton-module-scss-module__Csn2Wa__supportBadge",
  "supportButton": "SupportButton-module-scss-module__Csn2Wa__supportButton",
  "supportButtonGift": "SupportButton-module-scss-module__Csn2Wa__supportButtonGift",
  "supportButtonHeart": "SupportButton-module-scss-module__Csn2Wa__supportButtonHeart",
  "supportButtonIcon": "SupportButton-module-scss-module__Csn2Wa__supportButtonIcon",
  "supportButtonMediaQuery": "SupportButton-module-scss-module__Csn2Wa__supportButtonMediaQuery",
  "supportButtonPremium": "SupportButton-module-scss-module__Csn2Wa__supportButtonPremium",
  "supportButtonPrimary": "SupportButton-module-scss-module__Csn2Wa__supportButtonPrimary",
  "supportButtonRoyal": "SupportButton-module-scss-module__Csn2Wa__supportButtonRoyal",
  "supportButtonSparkle": "SupportButton-module-scss-module__Csn2Wa__supportButtonSparkle",
  "supportButtonText": "SupportButton-module-scss-module__Csn2Wa__supportButtonText",
  "supportHoverCard": "SupportButton-module-scss-module__Csn2Wa__supportHoverCard",
});
